/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useEffect, useRef, useState} from "react";
import {Tooltip} from '@mui/material';

export const TooltipOnOverflow = (props: any) => {
  const myRef = useRef<HTMLElement | null>(null);
  const [tooltipEnabled, setTooltipEnabled] = useState(false);
  useEffect(() => {
    const compareSize = () => {
      if (myRef.current) {
        const compare = myRef.current?.scrollWidth > myRef.current?.offsetWidth;
        setTooltipEnabled(compare);
      }
    };
    compareSize();
    window.addEventListener("resize", compareSize);
    return () => window.removeEventListener("resize", compareSize);
  }, []);

  const child: any = React.cloneElement(props?.children, {
    ref: (ref: any) => {
      if (ref != null) {
        myRef.current = ref
      }
    }
  })
  return (
    <Tooltip title={props?.title} disableHoverListener={!tooltipEnabled} placement={'right'}>
      {child}
    </Tooltip>
  );
};